import React, { useState, useRef,useEffect,useContext } from "react";
import { useSpring, animated } from '@react-spring/web';
import { ToastContainer, toast } from 'react-toastify';
import 'react-toastify/dist/ReactToastify.css';
import axios from "axios";
import {global} from '../App';
import file from "../imgs/file.svg";
import copyIcon from "../imgs/copyIcon.svg";
import SendEmail from './SendEmail'
  


export default function FileUpload() {
  const {newFile,setNewFile}=useContext(global);
  const [drag, setDrag] = useState(false);
  const [progress, setProgress] = useState(0)
  const[response,setResponse]=useState("")
  const [selectedFile,setSelectedFile]=useState(null);
  const [renderData,setRenderData] = useState({progress:false,sendemail:false});
  const URL = useRef(null);
  const copyText=useRef(null);
  const InputDialogBox=useRef(null);

  useEffect(() => {
    if(newFile)
    {
    setDrag(false);
    setProgress(0);
    setResponse("");
    setSelectedFile(null);
    setRenderData({progress:false,sendemail:false});
      
  }
  }, [newFile])
  
   let handleDrop = (e) => {
     setDrag(false);
     if (!selectedFile) {
       setRenderData({...renderData,progress:true})
       e.preventDefault();
       if (e.dataTransfer.files.length) {
         setNewFile(false);
         setSelectedFile(e.dataTransfer.files[0]);
       }
     }else toast("file already in process");

  };
  const handelFiles=()=>{
    if (!selectedFile) {
      
      if (InputDialogBox.current.files) {
        setNewFile(false);
        setSelectedFile(InputDialogBox.current.files[0]);
     toast("File selected"); }
    }else toast("file already in process");
  }
  

  useEffect(() => {
   if (selectedFile) {
      //file upload
      const formData = new FormData()
      formData.append("clientFile",selectedFile);
      axios.request({
        method: "post", 
        url: `${process.env.REACT_APP_SERVER_URL}/api/files/upload`, 
        data: formData, 
        onUploadProgress: (p) => {
          setNewFile(false);
          setRenderData({...renderData,progress:true})
          setProgress(Math.ceil(p.loaded*100/p.total))
        }
    }).then (data => {
        setResponse(data.data.File);
        setNewFile(false);
        setRenderData({...renderData,progress:true})
    })

        }

  }, [selectedFile]);
  

  const selectAll = (event) => {
    event.target.select();
  };

  // const copyAll = () => {
  //   navigator.clipboard.writeText(URL.current.value).then(() => {
  //     toast("👍  Link Copied")
  //   })
  //   .catch(() => {
  //     toast("something went wrong");
  //   });
  // };


//------------------------------component-
  function DragUpload (){
    return(
      <>
      
          <div className={drag ? "drop-zone animation" : "drop-zone"} onDrop={(e) => handleDrop(e)} onDragLeave={() => {setDrag(false);}}onDragOver={(e) => {e.preventDefault();setDrag(true);}}>
                  <div className="icon-container">
                      <img src={file}  height="100px" draggable="false"  className="center" alt="File Icon" onDragOver={() => { setDrag(true); }} />
                      <img src={file} height="100px" draggable="false" className="left" alt="File Icon"  onDragOver={() => {  setDrag(true); }}  />
                      <img src={file} height="100px" draggable="false" className="right" alt="File Icon" onDragOver={() => {setDrag(true); }}/>
                  </div>
                  <div className="Drop-text">
                    <input type="file" id="fileInput" onChange={handelFiles} ref={InputDialogBox} />Drop Your File Here ,Or &nbsp;<span className="browse" onClick={()=>{InputDialogBox.current.click()}}>browse</span>
                  </div>
                  {renderData.progress&&<div className="progress-container">
                    <div className="progressbg" style={{width:`${progress}%`}}></div>
                    <div className="progress-inner">Uploading <br/> {progress}%</div>
                  </div>}
          </div>
      </>
    );
  }

  const CopyFunction=()=>{
    // const textbox=document.getElementById("TextBox");
    URL.current.select()
     document.execCommand("copy")
     toast("👍  Link Copied")
     
  

  }
  //link copy section
  function LinkCopy (){
    let props = useSpring({ to: { opacity: 1,marginTop:0 }, from: { opacity: 0,marginTop:-100 } })
    return(
      <>
         <p className="expire">Link Expire in 24 hours</p>
          <animated.div style={props} className="share-container" >
            <input type="text" ref={URL} onClick={selectAll} readOnly id="fileURL" value={response} />
            <button className="copybtn" onClick={CopyFunction}>

            <img className="copylogo" ref={copyText} src={copyIcon} alt="Copy"/>
            
            </button>
          </animated.div>
      </>
      )
    }

    //send by email section
    

  return (
    <>
      <section className="main">
        <div className="upload-container">
          <DragUpload/>
         {response&&<LinkCopy/>}
         {response&&<SendEmail/>}
       </div>
       <ToastContainer position="bottom-center" autoClose={2000} />
      </section>
    </>
  );
}
